import React, { useState } from 'react';
import { Home, Users, Shield, Briefcase, Mail, Menu, X } from 'lucide-react';
import { navigationItems } from '../data/mock';

const iconMap = {
  Home,
  Users,
  Shield,
  Briefcase,
  Mail
};

const Sidebar = ({ activeSection, onNavigate }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);

  const handleNavClick = (sectionId) => {
    onNavigate(sectionId);
    setIsMobileOpen(false);
  };

  return (
    <div className="fixed top-0 left-0 z-50">
      {/* Mobile menu button */}
      <button
        onClick={() => setIsMobileOpen(!isMobileOpen)}
        className="fixed top-4 left-4 z-[60] md:hidden bg-[#FDFBF7] p-3 border-2 border-[#2D2D2D] sketch-border-1 sketch-shadow-sm"
        aria-label="Toggle menu"
      >
        {isMobileOpen ? (
          <X className="w-6 h-6 text-[#2D2D2D]" />
        ) : (
          <Menu className="w-6 h-6 text-[#2D2D2D]" />
        )}
      </button>

      {/* Mobile overlay */}
      {isMobileOpen && (
        <div
          className="fixed inset-0 bg-black/30 z-[55] md:hidden"
          onClick={() => setIsMobileOpen(false)}
        />
      )}

      {/* Sidebar */}
      <aside
        className={`fixed left-0 top-0 h-screen bg-[#FDFBF7] z-50
          transition-all duration-300 ease-in-out sidebar-sketch
          ${isExpanded ? 'w-60' : 'w-[70px]'}
          ${isMobileOpen ? 'translate-x-0' : '-translate-x-full md:translate-x-0'}
        `}
        onMouseEnter={() => setIsExpanded(true)}
        onMouseLeave={() => setIsExpanded(false)}
      >
        {/* Logo area */}
        <div className="p-4 border-b-2 border-[#2D2D2D]/20">
          <button
            onClick={() => setIsExpanded(!isExpanded)}
            className="w-full flex items-center justify-center md:justify-start gap-3 py-2"
            aria-label="Toggle sidebar"
          >
            {/* Hamburger icon - sketch style */}
            <div className="flex flex-col gap-1.5 w-6">
              <span className={`hamburger-line w-full transition-all ${isExpanded ? 'rotate-45 translate-y-2' : ''}`}></span>
              <span className={`hamburger-line w-full transition-all ${isExpanded ? 'opacity-0' : ''}`}></span>
              <span className={`hamburger-line w-full transition-all ${isExpanded ? '-rotate-45 -translate-y-2' : ''}`}></span>
            </div>
            {isExpanded && (
              <span className="font-patrick text-[#1F4E79] text-lg animate-fade-in-rotate hidden md:block">
                Menu
              </span>
            )}
          </button>
        </div>

        {/* Navigation items */}
        <nav className="p-4 space-y-3">
          {navigationItems.map((item, index) => {
            const IconComponent = iconMap[item.icon];
            const isActive = activeSection === item.id;
            
            return (
              <button
                key={item.id}
                onClick={() => handleNavClick(item.id)}
                className={`w-full flex items-center gap-4 p-3 transition-all duration-200
                  border-2 border-transparent
                  ${isActive 
                    ? 'bg-[#1F4E79] text-white border-[#2D2D2D] sketch-border-1 sketch-shadow-sm' 
                    : 'hover:bg-[#F08A24]/10 hover:border-[#2D2D2D] hover:sketch-border-1'
                  }
                `}
                style={{
                  borderRadius: '255px 15px 225px 15px / 15px 225px 15px 255px',
                  animationDelay: `${index * 0.1}s`
                }}
              >
                <IconComponent 
                  className={`w-5 h-5 flex-shrink-0 icon-sketch
                    ${isActive ? 'text-white' : 'text-[#1F4E79]'}
                  `}
                />
                {isExpanded && (
                  <span 
                    className={`font-architect text-base whitespace-nowrap animate-slide-in-left
                      ${isActive ? 'text-white' : 'text-[#2D2D2D]'}
                    `}
                  >
                    {item.label}
                  </span>
                )}
              </button>
            );
          })}
        </nav>

        {/* BAIM logo at bottom */}
        {isExpanded && (
          <div className="absolute bottom-4 left-0 right-0 px-4">
            <div className="border-t-2 border-[#2D2D2D]/20 pt-4">
              <img
                src="https://customer-assets.emergentagent.com/job_b4ea4401-b92b-497f-9584-a787add51601/artifacts/9szg6k9y_logo%20transparant.png"
                alt="BAIM Logo"
                className="w-20 h-auto mx-auto opacity-80"
              />
            </div>
          </div>
        )}
      </aside>
    </div>
  );
};

export default Sidebar;
